exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1{\r\n  color: #31568c;\r\n  margin: 0;\r\n  margin-top: 1em;\r\n  letter-spacing: 0.125em;\r\n  font-weight: 600;\r\n  font-size: 3em;\r\n  font-family: Georgia, serif;\r\n  padding: 1em .5em 1em .5em;\r\n  font-variant: small-caps;\r\n  clear: both;\r\n  text-align: center;\r\n}\r\n#logo{\r\n  width: auto;\r\n  display: block;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n}\r\n#logo img {\r\n  position: relative;\r\n  width: 70%;\r\n  max-width: 500px;\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  opacity: 0.7;\r\n  filter: alpha(opacity=70)\r\n}\r\n#logo h1 {\r\n  width: 100%;\r\n  height: 0px;\r\n  z-index: 100;\r\n  position: relative;\r\n  top: 1em;\r\n  color: white;\r\n  text-align: center;\r\n  font-weight: 700;\r\n  font-variant: small-caps;\r\n  font-size: 3.2em;\r\n}\r\n#subTitle{\r\n  text-align: center;\r\n  font-size: 1.8em;\r\n}\r\n#smallTitle{\r\n  font-size: .5em;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main